<template>
  <div class="form-wrapper green-inputs mb-5">
    <div class="frame-dash-underlined mb-3">
      <div class="row pb-4 align-items-center">
        <div class="col-12 col-md-5">
          <h2 class="h5 mb-0">VERANSTALTUNG FINDEN</h2>
        </div>
        <div class="col-12 col-md-7">
          <div class="row align-items-center">
            <div class="col-md-6 col-12 my-4 my-md-0">
              <div
                class="input-group floating-icon pill ophover"
                style="max-width: 17em"
              >
                <button
                  class="form-control text-center fullpill"
                  @click="resetFilters()"
                >
                  <i class="fas fa-times text-red"></i> Alle Filter zurücksetzen
            </button>
              </div>
            </div>
            <div class="col-md-6 col-12">
              <div class="input-group floating-icon pill grey-pill rounded-pill">
                <label for="freetext" class="sr-only">Freitext-Suche:</label>
                <input
                  class="form-control"
                  style="max-width: 12em;  border-radius: 999px 0px 0px 999px !important;"
                  @input="throttleUpdateValue($event, 's')"
                  :value="dataStore.params.s"
                   @keyup.enter="callApi(true)"
                   id="freetext"
                />
                <span class="input-group-text">
                  <i class="fa fa-search"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row my-4">
      <div
        class="col-12 col-md-6 d-md-flex mb-4 mb-md-0 justify-content-between align-items-center"
      >
        <label
          for="Veranstaltungsart"
          class="form-label d-block d-md-inline-block"
          >Veranstaltungsart:</label
        >
        <select
          id="Veranstaltungsart"
          class="form-select green-arrow withshadow twocorners"
          @input="updateValue($event, 'fbkat')"
           @keyup.enter="callApi(true)"
          :value="dataStore.params.fbkat"
        >
          <option v-for="op in veranopts" :value="op.code">
            {{ op.value }}
          </option>
        </select>
      </div>
      <div
        class="col-12 col-md-6 d-md-flex mb-4 mb-md-0 justify-content-between align-items-center"
      >
        <label for="Zielgruppe" class="form-label">Zielgruppe:</label>
        <select
          id="Zielgruppe"
          class="form-select green-arrow withshadow twocorners"
          @input="updateValue($event, 'zg')"
           @keyup.enter="callApi(true)"
          :value="dataStore.params.zg"
        >
          <option v-for="op in zielopts" :value="op.code">
            {{ op.value }}
          </option>
        </select>
      </div>
    </div>
    <div class="row my-4">
      <div class="col-12 col-lg-6 d-md-flex align-items-center mb-3 mb-md-0">
        <div class="form-label mb-0 fw-bold me-3">Veranstalter:</div>
        <div class="d-flex">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="Veranstalter"
              id="Veranstalter_0"
              value="-1"
              checked
              @input="updateValue($event, 'veranstalter')"
              :value="dataStore.params.veranstalter"
            />
            <label for="Veranstalter_0" class="form-check-label">Alle <span class="sr-only">Veranstalter</span></label>
          </div>
        </div>
        <div class="d-flex">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="Veranstalter"
              id="Veranstalter_1"
              value="N"
              @input="updateValue($event, 'veranstalter')"
              :value="dataStore.params.veranstalter"
            />
            <label for="Veranstalter_1" class="form-check-label"
              ><span class="sr-only">Veranstalter: </span>Apothekerkammer</label
            >
          </div>
        </div>
        <div class="d-flex">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="Veranstalter"
              id="Veranstalter_2"
              value="J"
              @input="updateValue($event, 'veranstalter')"
              :value="dataStore.params.veranstalter"
            />
            <label for="Veranstalter_2" class="form-check-label"
              ><span class="sr-only">Veranstalter:</span> Fremdveranstalter</label
            >
          </div>
        </div>
      </div>
      <div
        class="col-12 col-lg-6 d-md-flex mb-4 mb-md-0 justify-content-between align-items-center pe-lg-0"
      >
        <div class="row w-100 pe-lg-0">
          <div
            class="col-md-6 d-flex justify-content-between align-items-center mb-3 mb-md-0"
          >
            <label
              for="datumvon"
              class="form_label d-flex align-items-center"
              style="min-width: 2em"
              >Von:<span
                class="d-none d-md-inline-block"
                style="width: 6.33em"
              ></span
            ></label>
            <div class="input-group withshadow twocorners green-input-text">
              <input
                class="form-control unstyled"
                style="max-width: 12em"
                type="date"
                @input="throttleUpdateValue($event, 'von_dat')"
                :value="dataStore.params.von_dat"
                ref="fromDateRef"
                @focus="showFromDatePicker()"
                id="datumvon"
              />
              <span class="input-group-text">
                <button
                  class="fas fa-times-circle nobutt"
                  @click="emptyDatePicker('von_dat')"
                 aria-label="Feld Von-Datum zurücksetzen"
                >
           </button>
              </span>
            </div>
          </div>

          <div
            class="col-md-6 d-flex justify-content-between align-items-center pe-lg-0"
          >
            <label for="datumbis" class="form_label" style="min-width: 2em"
              >Bis:</label
            >
            <div class="input-group withshadow twocorners green-input-text">
              <input
                class="form-control unstyled"
                style="max-width: 12em"
                type="date"
                @input="throttleUpdateValue($event, 'bis_dat')"
                :value="dataStore.params.bis_dat"
                ref="toDateRef"
                @focus="showToDatePicker()"
                id="datumbis"
                :min="dataStore.params.von_dat"
              />
              <span class="input-group-text">
                <button
                  class="fas fa-times-circle nobutt"
                  @click="emptyDatePicker('bis_dat')"
                  aria-label="Feld Bis-Datum zurücksetzen"
                >
        
              </button>
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="col-12 col-md-6">
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              name="freiePlaetze"
              id="freiePlaetze"
              value="N"
              @input="updateValue($event, 'free')"
              :value="dataStore.params.free"
            />
            <label for="freiePlaetze" class="form-check-label text-green"
              >Zeige nur Veranstaltungen mit freien Plätzen</label
            >
          </div>
        </div> -->
      <div class="col-12 text-start mt-3">
        <div class="d-inline-block">
          <div class="input-group floating-icon pill ophover">
            <button
              class="form-control text-center fullpill"
              @click="callApi(true)"
              style="max-width: 14em !important; min-width: 10em"
            >
              Suchen
          </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, reactive, onMounted } from "vue";
import { storeToRefs } from "pinia";
import { useDataStore } from "@/store/";
import { debugLog } from "@/shared/utils";

const throttle = require("lodash/throttle");
const dataStore = useDataStore();
const loading = ref(false);
const { params, page } = storeToRefs(dataStore);
const fromDateRef = ref();
const toDateRef = ref();

const emptyFieldParams = {
  s: "",
  fbkat: "-1",
  zg: "*",
  veranstalter: "-1",
  freePlaces: "",
  von_dat: "",
  bis_dat: "",
};

dataStore.setParams({ ...emptyFieldParams });

const resetFilters = () => {
  dataStore.setParams({ ...emptyFieldParams });
};

const updateValue = (e, key) => {
  dataStore.setParams({ ...dataStore.params, [key]: e.target.value });
};

const throttleUpdateValue = throttle((e, key) => {
  dataStore.setParams({ ...dataStore.params, [key]: e.target.value });
}, 10);

const callApi = (resetPage = false) => {
  if(resetPage){
    dataStore.setPage(1);
    dataStore.setParams({ ...dataStore.params, page : 1 });
  }
  dataStore.callApi({
    beforeStart: () => {
      dataStore.loading.veranstaltungen = true;
    },
    afterEnd: () => {
      dataStore.loading.veranstaltungen = false;
      document.querySelector(".veranstaltungen .form-wrapper").scrollIntoView();
    },
  });
};

// PAGER
watch(
  page,
  (newVal, oldVal) => {
    if (newVal !== oldVal) {
      callApi();
    }
  }
);

onMounted(() => {
  dataStore.setUrl(process.env.VUE_APP_API_BASE + apiPointOut);
  callApi();
});

const showFromDatePicker = () => {
  fromDateRef.value.showPicker();
};

const showToDatePicker = () => {
  toDateRef.value.showPicker();
};

const emptyDatePicker = (paramKey) => {
  dataStore.params[paramKey] = "";
};

const optionsUp =
  typeof options === "undefined"
    ? '{"veranopts":[{"code":"-1","value":"Alle Ma\u00dfnahmen"},{"code":"1a","value":"1a) Seminar, Workshop, Praktikum"},{"code":"1b","value":"1b) Pharmazeutischer Qualit\u00e4tszirkel"},{"code":"2","value":"2) Kongress"},{"code":"3","value":"3) Live-Vortrag"}],"zielopts":[{"code":"*","value":"Alle Zielgruppen"},{"code":"01","value":"Apotheker\/in"},{"code":"02","value":"Apotheker\/in in Weiterbildung"},{"code":"03","value":"Apotheker\/in mit befristeter Berufserlaubnis"},{"code":"04","value":"PTA"},{"code":"05","value":"PTA in Ausbildung"},{"code":"06","value":"Pharmazeut\/in im Praktikum (PhiP) "},{"code":"07","value":"Pharmaziestudent\/in"},{"code":"08","value":"Pharmazieingenieur\/in"},{"code":"09","value":"Apothekerassistent\/in, Apothekenassistent\/in, pharmazeutische\/r Assistent\/in"},{"code":"12","value":"Arzt\/\u00c4rztin"},{"code":"13","value":"PKA"},{"code":"14","value":"PKA in Ausbildung "},{"code":"15","value":"Sonstige"}]}'
    : options;
const { veranopts, zielopts } = JSON.parse(optionsUp);

const apiPointOut =
  typeof apiPoint === "undefined"
    ? "http://akberlin:8888/fuer-mitglieder/aus-fort-und-weiterbildungaus-fort-und-weiterbildung/forbildung/veranstaltungen?tx_apis_calluniplus%5Baction%5D=callUniplus&tx_apis_calluniplus%5Bcontroller%5D=X3&tx_apis_calluniplus%5Bpath%5D=seminarwesen%2Fkurse%2F&type=871&cHash=7ba794e3bbef8570902b47cb1c8fe9a2"
    : apiPoint;

</script>
